export enum ETPermissions {
  NotarySigningAgent = 'Notary-Signing-Agent',
  NotaryNotary = 'Notary-Notary',
  LenderLoanOfficer = 'Lender-Loan-Officer',
  LenderClosingDepartment = 'Lender-Closing-Department',
  TitleSigningAgent = 'Title-Signing-Agent',
  Title = 'Title',
  Signor = 'Signor',
  ClosingCompany = 'Closing-Company',
}
export const ETPermissionsOptions = [
  ETPermissions.NotarySigningAgent,
  ETPermissions.NotaryNotary,
  ETPermissions.LenderLoanOfficer,
  ETPermissions.LenderClosingDepartment,
  ETPermissions.TitleSigningAgent,
  ETPermissions.Title,
  ETPermissions.Signor,
  ETPermissions.ClosingCompany,
];

/**
 * In packet it is used in originatorId field.
 * All ET companies will have the same id.
 * Used for different logic for ET companies.
 */
export const ET_COMPANIES_ID = 'fe2b4cfb-1001-4b55-a406-b9246b90c0eb';
